module.exports = __webpack_public_path__ + "static/media/mercedes-benz-go-drive.151edb8e.png";